<div id="json-wrapper">
  <tidy-text #jsonRender />
</div>
